import { render, staticRenderFns } from "./ServerBill.vue?vue&type=template&id=34629cd2&scoped=true"
import script from "./ServerBill.vue?vue&type=script&lang=js"
export * from "./ServerBill.vue?vue&type=script&lang=js"
import style0 from "./ServerBill.vue?vue&type=style&index=0&id=34629cd2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34629cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34629cd2')) {
      api.createRecord('34629cd2', component.options)
    } else {
      api.reload('34629cd2', component.options)
    }
    module.hot.accept("./ServerBill.vue?vue&type=template&id=34629cd2&scoped=true", function () {
      api.rerender('34629cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billManage/billList/components/ServerBill.vue"
export default component.exports